import { render, staticRenderFns } from "./FormLocales.vue?vue&type=template&id=f6bb0252&"
import script from "./FormLocales.vue?vue&type=script&lang=js&"
export * from "./FormLocales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports